var map = {
	"./Expenses report.inline.svg": "d7ad",
	"./Finances_Expenses.inline.svg": "59d3",
	"./Finances_Financial accounts.inline.svg": "c3b0",
	"./Finances_Invoices.inline.svg": "5cbf",
	"./Finances_Legal entities.inline.svg": "0ec6",
	"./Finances_Payouts.inline.svg": "c262",
	"./Finances_Payrolls.inline.svg": "4c6c",
	"./Finances_Transactions.inline.svg": "bde6",
	"./Reports_Balances report.inline.svg": "d0ce",
	"./Reports_By people & project.inline.svg": "fbde",
	"./Reports_Cashflow.inline.svg": "b7c6",
	"./Reports_Financial dashboard.inline.svg": "f76d",
	"./Reports_Financial reports.inline.svg": "b155",
	"./Reports_Hours & payments.inline.svg": "e306",
	"./Reports_Hours tracking report.inline.svg": "f383",
	"./Reports_Invoices report.inline.svg": "483f",
	"./Reports_KPI.inline.svg": "21d7",
	"./Reports_Log time report.inline.svg": "b2f8",
	"./Reports_Operations reports.inline.svg": "c83a",
	"./Reports_P&L.inline.svg": "c27d",
	"./Reports_Sales report.inline.svg": "c740",
	"./Reports_Time managment reports.inline.svg": "6e7e",
	"./Reports_Time off report.inline.svg": "8e17",
	"./Schedule_Booking table.inline.svg": "561f",
	"./Schedule_Work schedule.inline.svg": "d0dd",
	"./Tenant settings_Business & operations.inline.svg": "ab8f",
	"./Tenant settings_Chart of accounts.inline.svg": "e58e",
	"./Tenant settings_Financial accounts.inline.svg": "b22d",
	"./Tenant settings_Holidays & schedule.inline.svg": "d97a",
	"./Tenant settings_Holidays.inline.svg": "f89b",
	"./Tenant settings_Integrations - Jira.inline.svg": "5812",
	"./Tenant settings_Integrations.inline.svg": "fd95",
	"./Tenant settings_Legal entities.inline.svg": "c13d",
	"./Tenant settings_Organization details.inline.svg": "87f9",
	"./Tenant settings_Organization.inline.svg": "6100",
	"./Tenant settings_Permissions table.inline.svg": "cc8e",
	"./Tenant settings_Personnel & reporting.inline.svg": "3c37",
	"./Tenant settings_Plan & billing.inline.svg": "e081",
	"./Tenant settings_Sales channels.inline.svg": "4bd1",
	"./Tenant settings_Skills.inline.svg": "a5fd",
	"./Tenant settings_Specialisation items.inline.svg": "bb35",
	"./Tenant settings_System settings.inline.svg": "0595",
	"./Tenant settings_Tax types.inline.svg": "82a9",
	"./Tenant settings_Time Off Settings.inline.svg": "caec",
	"./contacts_All.inline.svg": "c329",
	"./contacts_clients.inline.svg": "71ad",
	"./contacts_partners.inline.svg": "eff7",
	"./project_Project list.inline.svg": "b39a",
	"./project_boards.inline.svg": "3a15",
	"./project_tasks.inline.svg": "78c5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7024";